import {computed, ComputedRef} from "vue"
import transportPackCode from "@/config/transportPackCode"
import flightPackCode from "@/config/flightPackCode"
import store from "@/vue/planning/store/store"

const availableTransportPackCodes: ComputedRef<Array<any>> = computed(() => {
    const availableTransportPackCodes = store.getters.availablePackCodes.filter((codeObjPackage: any) => {
        // if ([...flightPackCode, ...transportPackCode].includes(codeObjPackage.codePackage)) return true; REMOVED UNTIL I UNDERSTAND THE INTENTIONS OF MANAGERS
        if (transportPackCode.includes(codeObjPackage.codePackage)) return true;
    });

    return availableTransportPackCodes;
})

export default availableTransportPackCodes